import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import ImageSliderContent
  from 'components/dashboard/image-slider/ImageSliderContent';

const DashboardSlidersPage = () => (
  <LinksPageLayout activeLinksPage="sliders">
    <ImageSliderContent />
  </LinksPageLayout>
);

export default DashboardSlidersPage;
